module.exports = __webpack_public_path__ + "img/1440.5adc82e1.jpg";